/** Logical canvas for The Wombafleks minigame (authoring space). */
export const WOMBAFLEKS_CATCH_LOGICAL_WIDTH = 1920;
export const WOMBAFLEKS_CATCH_LOGICAL_HEIGHT = 1080;

export const WOMBAFLEKS_CATCH_BACKGROUND_SRC = '/minigames/trophy_room.jpg';
export const WOMBAFLEKS_CATCH_SPRITE_SRC = '/minigames/wombafleks.png';

export const WOMBAFLEKS_CATCH_REPOSITION_SOUND_SRCS = Object.freeze([
  '/minigames/wombafleks1.mp3',
  '/minigames/wombafleks2.mp3',
]);
export const WOMBAFLEKS_CATCH_SUCCESS_SOUND_SRC = '/minigames/wombafleks3.mp3';

/**
 * @returns {string}
 */
export function pickRandomWombafleksRepositionSoundSrc() {
  const idx = Math.floor(Math.random() * WOMBAFLEKS_CATCH_REPOSITION_SOUND_SRCS.length);
  return WOMBAFLEKS_CATCH_REPOSITION_SOUND_SRCS[idx];
}

/** Server `minigames.wombafleksCatch.positionIntervalMs` */
export const WOMBAFLEKS_CATCH_POSITION_INTERVAL_MS = 1000;
/** Server `minigames.wombafleksCatch.timerDurationMs` */
export const WOMBAFLEKS_CATCH_TIMER_DURATION_MS = 60_000;

/** `pickedTreeIndex` sent to complete API on catch (must match server `winPickValue`). */
export const WOMBAFLEKS_CATCH_WIN_PICK_VALUE = 1;
/** `pickedTreeIndex` sent on timeout / failed attempt. */
export const WOMBAFLEKS_CATCH_LOSS_PICK_VALUE = 0;

/** Play area for random spawns (logical px), below the instruction strip. */
export const WOMBAFLEKS_CATCH_SPAWN_BOUNDS = Object.freeze({
  xMin: 120,
  xMax: 1800,
  yMin: 200,
  yMax: 980,
});

/**
 * @param {number} logicalX
 * @param {number} logicalY
 * @returns {{ left: string, top: string }}
 */
export function wombafleksLogicalToPercentPosition(logicalX, logicalY) {
  if (!Number.isFinite(logicalX) || !Number.isFinite(logicalY)) {
    throw new Error(`wombafleksLogicalToPercentPosition: invalid coords (${logicalX}, ${logicalY})`);
  }
  return {
    left: `${(logicalX / WOMBAFLEKS_CATCH_LOGICAL_WIDTH) * 100}%`,
    top: `${(logicalY / WOMBAFLEKS_CATCH_LOGICAL_HEIGHT) * 100}%`,
  };
}

/**
 * @returns {[number, number]}
 */
export function pickRandomWombafleksLogicalPosition() {
  const { xMin, xMax, yMin, yMax } = WOMBAFLEKS_CATCH_SPAWN_BOUNDS;
  const x = xMin + Math.floor(Math.random() * (xMax - xMin + 1));
  const y = yMin + Math.floor(Math.random() * (yMax - yMin + 1));
  return [x, y];
}

/**
 * @param {number} msRemaining
 * @returns {string}
 */
export function formatWombafleksTimerLabel(msRemaining) {
  if (!Number.isFinite(msRemaining) || msRemaining < 0) {
    throw new Error(`formatWombafleksTimerLabel: invalid ms (${String(msRemaining)})`);
  }
  const totalSec = Math.ceil(msRemaining / 1000);
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return `${min}:${String(sec).padStart(2, '0')}`;
}
